import { TimelineImageItem, TimelineTextItem } from './timeline-item'

export function Timeline() {
  return (
    <section className="flex flex-col gap-4">
      <TimelineImageItem
        title="รับสมัครวันสุดท้าย!"
        description="ประกวดออกเเบบตราสัญลักษณ์เนื่องในโอกาสเฉลิมฉลองครบรอบ 60 ปีความสัมพันธ์ทางการทูตสิงคโปร์ - ไทยในปี 2568"
        durationText="1 hour ago"
      />
      <TimelineImageItem
        title="รับสมัครวันสุดท้าย!"
        description="ประกวดออกเเบบตราสัญลักษณ์เนื่องในโอกาสเฉลิมฉลองครบรอบ 60 ปีความสัมพันธ์ทางการทูตสิงคโปร์ - ไทยในปี 2568"
        durationText="1 hour ago"
      />
      <TimelineTextItem
        title="รับสมัครวันสุดท้าย!"
        durationText="2 hours ago"
        disabled
      />
      <TimelineImageItem
        title="รับสมัครวันสุดท้าย!"
        description="ประกวดออกเเบบตราสัญลักษณ์เนื่องในโอกาสเฉลิมฉลองครบรอบ 60 ปีความสัมพันธ์ทางการทูตสิงคโปร์ - ไทยในปี 2568"
        durationText="1 hour ago"
        disabled
      />
      <TimelineImageItem
        title="รับสมัครวันสุดท้าย!"
        description="ประกวดออกเเบบตราสัญลักษณ์เนื่องในโอกาสเฉลิมฉลองครบรอบ 60 ปีความสัมพันธ์ทางการทูตสิงคโปร์ - ไทยในปี 2568"
        durationText="1 hour ago"
        disabled
      />
      <TimelineTextItem
        title="รับสมัครวันสุดท้าย!"
        durationText="2 hours ago"
        disabled
      />
      <TimelineTextItem
        title="รับสมัครวันสุดท้าย!"
        durationText="2 hours ago"
        disabled
      />
    </section>
  )
}
